import classNames from 'classnames'
import PropTypes from 'prop-types'

import classes from './FilterSelect.module.scss'

const FilterSelect = ({ id, value, onChange, options, placeholder }) => (
  <div className={classNames(classes.filterSelect, 'position-relative')}>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={classNames(classes.select, { [classes.active]: value !== '' })}
    >
      <option value=''>{placeholder}</option>
      {options.map(option => (
        <option key={option.value} value={option.value}>{option.label}</option>
      ))}
    </select>
    <i className={classNames('fa fa-chevron-down', classes.chevron)} aria-hidden='true' />
  </div>
)

FilterSelect.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  placeholder: PropTypes.string.isRequired,
}

export default FilterSelect
